import phoneSettingsIndex from '@/views/phoneSettings/phoneSettingsIndex.vue'

export default {
  path: '/phoneSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'phoneSettingsIndex',
      name: 'phoneSettingsIndex',
      component: phoneSettingsIndex
    },


  ]
}
